document.addEventListener("DOMContentLoaded", () => {
  const container = document.getElementById("categories");
  const leftBtn = document.querySelector(".js-cat-left");
  const rightBtn = document.querySelector(".js-cat-right");

  if (!container || !leftBtn || !rightBtn) return;

  const scrollAmount = 200;

  function updateArrows() {
    const maxScrollLeft = container.scrollWidth - container.clientWidth;

    // Show arrows only if scroll exists
    if (maxScrollLeft <= 0) {
      leftBtn.classList.add("hidden");
      rightBtn.classList.add("hidden");
      return;
    }

    // Show both initially
    leftBtn.classList.remove("hidden");
    rightBtn.classList.remove("hidden");

    // Left edge
    if (container.scrollLeft <= 0) {
      leftBtn.classList.add("hidden");
    } else {
      leftBtn.classList.remove("hidden");
    }

    // Right edge
    if (container.scrollLeft >= maxScrollLeft - 1) {
      rightBtn.classList.add("hidden");
    } else {
      rightBtn.classList.remove("hidden");
    }
  }

  leftBtn.addEventListener("click", () => {
    container.scrollBy({ left: -scrollAmount, behavior: "smooth" });
  });

  rightBtn.addEventListener("click", () => {
    container.scrollBy({ left: scrollAmount, behavior: "smooth" });
  });

  container.addEventListener("scroll", updateArrows);
  window.addEventListener("resize", updateArrows);

  // initial check
  updateArrows();
});